// @flow
import React from 'react'

type Props = {
  pathProps?: any,
  svgProps?: any,
}

const Plus = (props: Props) => {
  const pathProps = props.pathProps || {}
  const svgProps = props.svgProps || {}
  return (
    <svg width="96" height="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <g transform="translate(-672.000000, -432.000000)">
        <path
          fill="#EBEEF0"
          fillRule="evenodd"
          {...pathProps}
          d="M724,476 L724,461 L716,461 L716,476 L701,476 L701,484 L716,484 L716,499 L724,499 L724,484 L739,484 L739,476 L724,476 Z M720,528 C693.490332,528 672,506.509668 672,480 C672,453.490332 693.490332,432 720,432 C746.509668,432 768,453.490332 768,480 C768,506.509668 746.509668,528 720,528 Z"
        />
      </g>
    </svg>
  )
}

export default Plus
